
import { Button } from '../../../components/base/Button';

export const AboutSection = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="about" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-flex items-center text-cyan-600 text-sm font-medium mb-6">
              <span className="w-2 h-2 bg-cyan-600 rounded-full mr-2"></span>
              About Us
            </div>
            
            <h3 className="text-4xl md:text-5xl font-serif text-navy-900 leading-tight mb-8">
              <span className="font-normal">Protecting</span><br />
              <span className="font-bold">Digital Privacy</span><br />
              <span className="font-light text-cyan-600">Since Day One</span>
            </h3>
            
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              DUVANKA DOO is a Serbian technology company dedicated to developing secure applications 
              that protect user privacy and digital freedom. Our VPN solution represents years of 
              expertise in cybersecurity and commitment to user protection.
            </p>
            
            <Button 
              onClick={() => scrollToSection('contact')}
              className="mb-8"
            >
              Contact Our Team
              <i className="ri-arrow-right-line ml-2"></i>
            </Button>
            
            <div className="text-sm text-gray-500 space-y-1">
              <p>DUVANKA DOO</p>
              <p>Bulevar Oslobodilaca Cacka 105G</p>
              <p>Cacak 520288, Serbia</p>
            </div>
          </div>
          
          <div className="relative">
            <div className="bg-white rounded-3xl p-8 shadow-2xl transform rotate-2 hover:rotate-0 transition-transform duration-300">
              <img 
                src="https://public.readdy.ai/ai/img_res/6a7cb51f4115b687a2ba5c13da7bd699.jpg"
                alt="DUVANKA Technology Visualization"
                className="w-full h-64 object-cover rounded-2xl"
              />
              
              <div className="absolute top-4 left-4">
                <span className="bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-navy-900 text-sm font-medium">
                  Est. Serbia
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
